export default function displayName(componentName) {
  return `view-components:${componentName}`;
}
